if (!customElements.get('icraft-home-picks')) {
  customElements.define('icraft-home-picks', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const signal = this.events.signal;
      const buttons = [...this.querySelectorAll('[data-home-filter]')];
      const products = [...this.querySelectorAll('[data-home-product]')];
      this.querySelector('.ih-filters').hidden = false;
      this.compareObserver = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) {
          this.compareObserver.disconnect();
          this.initCompare(signal);
        }
      }, {rootMargin: '200px'});
      this.compareObserver.observe(this);
      document.addEventListener('icraft:compare-changed', event => {
        if (!event.detail?.source || !this.contains(event.detail.source)) return;
        const notice = this.querySelector('[data-home-compare-notice]');
        const title = event.detail.source.closest('.ih-product').querySelector('h3').textContent;
        notice.textContent = `${this.dataset[event.detail.action] || this.dataset.updated} · ${title}`;
        notice.hidden = false;
        clearTimeout(this.noticeTimer);
        this.noticeTimer = setTimeout(() => { notice.hidden = true; }, 4000);
        if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
          notice.animate([{opacity:0,transform:'translateY(8px)'},{opacity:1,transform:'translateY(0)'}],{duration:200});
        }
      }, {signal});
      buttons.forEach(button => button.addEventListener('click', () => {
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        products.forEach(product => {
          product.hidden = button.dataset.homeFilter !== 'all' && button.dataset.homeFilter !== product.dataset.homeProduct;
        });
      }, {signal}));
    }
    async initCompare(signal) {
      if (!this.querySelector('.js-compare-checkbox')) return;
      const tag = document.getElementById('compare-resources');
      try {
        if (tag) {
          const resources = JSON.parse(tag.textContent);
          tag.remove();
          for (const resource of resources) {
            if (resource.type === 'css') {
              const link = document.createElement('link');
              link.rel = 'stylesheet'; link.href = resource.path; document.head.append(link);
            } else if (resource.type === 'js') {
              await new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.src = resource.path; script.onload = resolve; script.onerror = reject;
                document.head.append(script);
              });
            }
          }
        }
        await customElements.whenDefined('compare-drawer');
        if (signal.aborted || !this.isConnected) return;
        this.querySelectorAll('.js-compare-checkbox').forEach(input => { input.disabled = false; });
      } catch {
        // Preserve the product links and purchase controls if optional compare fails to load.
      }
    }
    disconnectedCallback() { this.events?.abort(); this.compareObserver?.disconnect(); clearTimeout(this.noticeTimer); }
  });
}
